import { render, staticRenderFns } from "./customsDeclaration.vue?vue&type=template&id=1ff0c3bc&"
import script from "./customsDeclaration.vue?vue&type=script&lang=js&"
export * from "./customsDeclaration.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../../Users/qiancheng/Documents/Workspace/cargoware/cargoware-h5-haichuang/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/Users/qiancheng/Documents/Workspace/cargoware/cargoware-h5-haichuang/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('1ff0c3bc')) {
      api.createRecord('1ff0c3bc', component.options)
    } else {
      api.reload('1ff0c3bc', component.options)
    }
    module.hot.accept("./customsDeclaration.vue?vue&type=template&id=1ff0c3bc&", function () {
      api.rerender('1ff0c3bc', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/uiCustom/se/basic/customsDeclaration.vue"
export default component.exports